import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { UserService } from '../../../services/User/UserService'

export interface IUserDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  user: any
  leastDestructiveRef: any
}

export function UserDeleteDialog({ isOpen, onClose, user, leastDestructiveRef }: IUserDeleteDialogProps) {
  const userService = new UserService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await userService.destroy(user.id)

      toast({
        title: 'Usuário excluído',
        description: 'Usuário excluído com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao excluir usuário',
        description: 'Erro ao excluir usuário, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Remover usuário {user.name}
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
